module.exports = __webpack_public_path__ + "img/loginPasscode01.png";